import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ParticipantApp from "./pages/ParticipantApp.jsx";
import MirrorForm from "./pages/MirrorForm.jsx";
import AdminApp from "./pages/AdminApp.jsx";
import AdminDetail from "./pages/AdminDetail.jsx";
import Missing from "./pages/Missing.jsx";
import "./styles/app.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/j/:token" element={<ParticipantApp />} />
        <Route path="/m/:token" element={<MirrorForm />} />
        <Route path="/admin" element={<AdminApp />} />
        <Route path="/admin/participant/:id" element={<AdminDetail />} />
        <Route path="/" element={<Missing />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
